$('.btn-inventory__add, .btn-inventory__remove').on('click', function () {
    var $this       = $(this),
        $parent     = $this.parent('td'),
        $value      = $this.data('value'),
        $itemID     = $parent.data('item-id'),
        $btnAdd     = $parent.find('.btn-inventory__add'),
        $btnRemove  = $parent.find('.btn-inventory__remove');

    $.ajax({
        url: '/ajax/item/'+$itemID+'/change-inventory-sign',
        method: 'PUT',
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        data: {value: $value},
        success: function (resp) {
            $btnAdd.toggleClass('disabled');
            $btnRemove.toggleClass('disabled');
        }
    });
});